import { FC } from 'react';

import { Svg, SvgProps } from '../../components/Svg/Svg.styles';

export const UserIcon: FC<SvgProps> = (props) => (
  <Svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" data-no-fill xmlns="http://www.w3.org/2000/svg">
    <path stroke="currentcolor" strokeLinejoin="round" strokeWidth="1.333" d="M10.333 4.333a2.333 2.333 0 1 1-4.666 0 2.333 2.333 0 0 1 4.666 0ZM8 8.667c-2.26 0-3.976 1.343-4.678 3.242-.273.736.357 1.424 1.143 1.424h7.07c.786 0 1.416-.688 1.143-1.424-.702-1.9-2.417-3.242-4.678-3.242Z" />
  </Svg>
);
